import { render, staticRenderFns } from "./upComing.vue?vue&type=template&id=63818df0&scoped=true"
import script from "./upComing.vue?vue&type=script&lang=js"
export * from "./upComing.vue?vue&type=script&lang=js"
import style0 from "./upComing.vue?vue&type=style&index=0&id=63818df0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63818df0",
  null
  
)

export default component.exports